import React from 'react';
import { DeclineHistory } from 'modules/entertainment-videos/types';
import { getDisplayDateAndTime } from 'utils/date';
import './entertainment-video-decline-history.scss';

export function EntertainmentVideoDeclineHistory({
  declineHistory
}: {
  declineHistory: Array<DeclineHistory>
}) {
  if (declineHistory.length === 0) {
    return <span>–</span>;
  }

  const sortedHistory = declineHistory.slice().sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return (
    <ul className="ev-decline-history-list">
      {sortedHistory.map((h) => (
        <li className="ev-decline-history-list__item" key={h.text}>
          <p className="ev-decline-history-list__text">{h.text}</p>
          <p className="ev-decline-history-list__date">
            {getDisplayDateAndTime(h.date)}
          </p>
        </li>
      ))}
    </ul>
  );
}
